export const useDragAndDrop = () => {
  const handleDrop = (
    e,
    fileInputRef,
  ) => {
    e.preventDefault();

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      if (fileInputRef.current) {
        const dt = new DataTransfer();
        Array.from(e.dataTransfer.files).forEach((file) => dt.items.add(file));
        fileInputRef.current.files = dt.files;

        const event = new Event("change", { bubbles: true });
        fileInputRef.current.dispatchEvent(event);
      }
    }
  };

  return {
    handleDrop,
  };
};
